import Header from "../../Common/Header";
import About from "./About/AboutUs";
import Advisors from "./Advisors/Advisors";
import Bank from "./Bank/Bank";
import Leader from "./Leadership/Leader";
import Manager from "./Management/Manager";
import BackOffice from "./Inst BackOffice/BackOffice";
// import Research from "./Inst Research/Research"
import Mission from "./Mission/Mission";

export default function AboutUs() {
  return (
    <main>
      <Header />
      <About />
      <Mission />
      <Leader />
      <Manager />
      <BackOffice/>
      {/* <Research/> */}
      <Bank />
    </main>
  );
}
